import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { TAddress } from '../../types';

export type TManagersAndRepresentatives = {
  assetManagers: TAssetManager[] | null;
  isUnifiedAccountAccess: boolean;
  isClientRepresentativesAbsent: boolean;
  isAnyAssetManagerDataChanged: boolean | null;
  clientRepresentatives: TClientRepresentative[] | null;
};

export type TAssetManager = {
  id: string | null;
  lastName: string | null;
  firstName: string | null;
  middleName: string | null;
  identificationNumber: string | null;
  foreignTaxNumber: string | null;
  contactNumbers: string[] | null;
  emailAddress: string[] | null;
  position: TAutocompleteOption | null;
  signatureAuthorityDetails: TAutocompleteOption | null;
  verificationStatus: string | null;
  authorityTermType: AuthorityTermType | null;
  authorityExpirationDate?: string | null;
  accessAfterAuthorityExpiration?: AccessAfterAuthorityExpiration | null;
  isHead: boolean;
};

export type TClientRepresentative = {
  lastName: string | null;
  firstName: string | null;
  middleName: string | null;
  identificationNumber: string | null;
  foreignTaxNumber: string | null;
  citizenshipCountry: TAutocompleteOption | null;
  residenceCountry: TAutocompleteOption | null;
  address: TAddress;
};

export enum ManagerVerificationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
}

export enum AccessAfterAuthorityExpiration {
  ACCESS_DENIED = 'ACCESS_DENIED',
  LOGIN_ALLOWED_SIGNING_DENIED = 'LOGIN_ALLOWED_SIGNING_DENIED',
}

export enum AuthorityTermType {
  UNLIMITED = 'UNLIMITED',
  UNTIL_DATE = 'UNTIL_DATE',
}

export interface IUpdateStatusesProps {
  assetManagers: TAssetManager[] | null;
  applicationId?: number;
  callbackFunc: (index: number, manager: TAssetManagerStatusResponse) => void;
}

export type TStatusResponse = {
  data: { assetManagers: TAssetManagerStatusResponse[] };
};

export type TAssetManagerStatusResponse = {
  status: ManagerVerificationStatus;
  assetManagerId: string;
};
